const baseTheme = {
  colors: {
    // ── Backgrounds
    bgCream: "#FAF9F5",
    bgWarm: "#F5F1E8",
    surfaceWhite: "#FFFFFF",

    // ── Ink (dark text / dark surfaces)
    ink: "#23211C",
    ink2: "#1C1A16",
    inkSoft: "#5F584A",

    // ── Muted / secondary text
    muted: "#7A7261",
    muted2: "#9A917E",

    // ── Borders / dividers
    taupeLine: "rgba(194, 181, 158, 0.42)",
    border: "#ECE6D8",
    borderSoft: "#F0ECE2",

    // ── Brand coral
    coral: "#D97757",
    coralDeep: "#B65A37",
    coralSoft: "#FBEFE6",

    // ── Gold
    gold: "#E0A03D",
    goldSoft: "#F3E4C4",

    // ── Legacy aliases (no borrar — algunos styled-components aún los usan)
    primaryGreen: "#D97757",        // coral reemplaza el verde
    primaryGreenSoft: "#FBEFE6",
    primaryGreenBorder: "rgba(217, 119, 87, 0.24)",
    primaryGreenGlow: "rgba(217, 119, 87, 0.08)",
    primaryGray: "#9A917E",
    white: "#FFFFFF",
    black: "#23211C",
    grayLight: "#F0ECE2",
    gray: "#B7AF9F",
    grayDark: "#7A7261",

    // ── Legacy gradient backgrounds (ya no se usan en pantallas nuevas)
    bgWhiteBlur: "linear-gradient(180deg, #f5f1e8 0%, #f1ebe0 100%)",
    bgBlackBlur: "rgba(35, 33, 28, 0.08)",
    bgGrayLightBlur: "linear-gradient(270deg, #ECE6D8 0%, rgba(236, 230, 216, 0) 100%)",
    bgGrayBlur: "linear-gradient(90deg, rgba(236, 230, 216, 0.31) 0%, rgba(240, 236, 226, 0.3) 100%)",
  },
  fonts: {
    family: {
      fontPrimary: "'Hanken Grotesk', sans-serif",
      display: "'Space Grotesk', sans-serif",
      mono: "'Space Mono', monospace",
    },
    weight: {
      thin: 300,
      light: 400,
      medium: 500,
      regular: 500,
      semiBold: 600,
      bold: 700,
      heavy: 800,
    },
    size: {
      xs: "10px",
      sm: "12px",
      md: "16px",
      lg: "18px",
      lg2: "24px",
      xl1: "28px",
      xl2: "31px",
    },
  },
  radius: {
    chip: "8px",
    input: "13px",
    button: "11px",
    card: "18px",
    pill: "99px",
  },
  boxShadow: {
    grayBoxShadow: "0 14px 28px rgba(123, 104, 78, 0.06)",
    cardBoxShadow: "0 18px 36px rgba(123, 104, 78, 0.08)",
    pillBoxShadow: "0 2px 2px rgba(35, 33, 28, 0.06)",
    authCard: "0 34px 80px -30px rgba(35, 33, 28, 0.5)",
  },
};

export default baseTheme;
